/**
 * A list of the custom status codes returned by the server.
 */
export const customStatusCodes = {
  SESSION_EXPIRED: 432,
};
